<template>
    <div class="absolute" ref="root">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'vx-window-pane',
    props: {
        draggableClass: {
            type: String
        }
    },
    watch: {
        draggableClass: {
            handler: function (newV, oldV) {
                this.findElements(newV)
            }
        },
        draggableElements: {
            handler: function (newV, oldV) {
                if (oldV) {
                    oldV.forEach((el) => {
                        el.removeEventListener('mousedown', this.dragStart)
                    })
                }
                if (newV) {
                    newV.forEach((el) => {
                        el.addEventListener('mousedown', this.dragStart)
                    })
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            pos1: 0,
            pos2: 0,
            pos3: 0,
            pos4: 0,
            draggableElements: [],
            windowHeight: 0
        }
    },
    computed: {
        draggable() {
            return this.$refs.root
        }
    },
    methods: {
        findElements(selector) {
            var elements = this.$refs.root.querySelector(`.${selector}`)
            if (!elements) {
                this.draggableElements = []
                return
            }
            if (Array.isArray(elements)) {
                this.draggableElements = elements
                return
            }
            this.draggableElements = [elements]
        },
        dragStart(e) {
            e = e || window.event
            e.preventDefault()

            this.pos3 = e.clientX
            this.pos4 = e.clientY
            document.addEventListener('mouseup', this.stopDrag)
            document.addEventListener('mousemove', this.move)
        },
        move(e) {
            e = e || window.event
            e.preventDefault()
            this.pos1 = this.pos3 - e.clientX
            this.pos2 = this.pos4 - e.clientY
            this.pos3 = e.clientX
            this.pos4 = e.clientY

            var newTop = this.draggable.offsetTop - this.pos2
            var maxTop = this.windowHeight - this.draggable.offsetHeight

            var newLeft = this.draggable.offsetLeft - this.pos1
            var maxLeft = this.draggable.offsetParent.offsetWidth - this.draggable.offsetWidth

            if (newLeft < 0) {
                newLeft = 0
            } else if (newLeft > maxLeft) {
                newLeft = maxLeft
            }

            if (newTop < 0) {
                newTop = 0
            } else if (newTop > maxTop) {
                newTop = maxTop
            }

            this.draggable.style.top = newTop + 'px'
            this.draggable.style.left = newLeft + 'px'
        },
        stopDrag(e) {
            this.removeListeners()
        },
        removeListeners(e) {
            document.removeEventListener('mouseup', this.stopDrag)
            document.removeEventListener('mousemove', this.move)
        }
    },
    mounted() {
        this.findElements(this.draggableClass)
        this.windowHeight =
            window.innerHeight - this.draggable.offsetParent.getBoundingClientRect().top
    },
    beforeDestroy() {
        this.removeListeners()
    }
}
</script>

<style scoped lang="scss"></style>
